<script>
import BackgroundIllustration from '@/components/BackgroundIllustration'
import ViewTitle from '@/components/ViewTitle'
import Actualities from '@/views/Actualities'
import CalEventItem from '@/components/vue-calendar/components/cal-event-item'
import UsefulInfoCollapsible from '@/components/UsefulInfoCollapsible'
import StoreCard from '@/components/StoreCard'
import ActualitiesServices from '@/services/actualities'
import EventsServices from '@/services/events'
import StoresServices from '@/services/stores'
import UsefulInfoServices from '@/services/usefulInfo'
import EnvironmentUtils from '@/utils/environmentUtils'
import DOMUtils from '@/utils/DOMUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'

export default
{
    name: 'favorites',

    created ()
    {
        const cityId = EnvironmentUtils.cityId

        ActualitiesServices.fetchActualities(cityId, null, {from: 0, number: 30, excludeContent: true}).then(actualities =>
        {
           this.$store.commit('actualities/updateActualityList', actualities)
        })
        EventsServices.fetchEvents(cityId).then(events  =>
        {
            this.$store.commit('events/updateEventList', events)
        })
        UsefulInfoServices.fetchInfos(cityId).then(infos  =>
        {
            this.$store.commit('usefulInfos/updateInfoList', infos)
        })
        StoresServices.fetchStores(cityId).then(stores  =>
        {
            this.$store.commit('stores/updateStoreList', stores)
        })
    },

    render () 
    {
        const favorites = this.$store.state.favorites
        const favoriteActualities = this.$store.state.actualities.actualityList.filter(a => favorites.actualities.includes(a.id))
        const favoriteEvents = this.$store.state.events.eventList.filter(e => favorites.events.includes(e.id))
        const favoriteUsefulInfos = this.$store.state.usefulInfos.infoList.filter(i => favorites.usefulInfos.includes(i.id))
        const favoriteStores = this.$store.state.stores.storeList.filter(s => favorites.stores.includes(s.id))
        const favoriteElementsCount = favoriteActualities.length + favoriteEvents.length + favoriteUsefulInfos.length
            + favoriteStores.length

        return (
            <div id='favorites-view'>
                <view-title>Mes favoris</view-title>
                
                <background-illustration v-show={favoriteElementsCount == 0} image={require('@/assets/img/heart-eyes.svg')}
                    message={'Vous n\'avez pas encore de favoris.\nVous pouvez ajouter des actualités, événements ou'
                    + ' informations utiles à vos favoris grâce aux cœurs présents sur ces éléments.'} />
                
                <div id='favorite-elements' ref='favoriteElements'>
                {
                    favoriteUsefulInfos.map(i =>
                    {
                        return <div class='element'>
                            <useful-info-collapsible info={i} />
                        </div>
                    })
                }
                {
                    favoriteActualities.map(a =>
                    {
                        return <div class='element'>
                         { Actualities.methods.createActualityCard(h, a, (e, tile) => this.$router.push('actualities/' + a.id)) }
                        </div>
                    })
                }
                {
                    favoriteEvents.map(e =>
                    {
                        return <div class='element'>
                            <cal-event-item event={e} editable={false} />
                        </div>
                    })
                }
                {
                    favoriteStores.map(s =>
                    {
                        return <div class='element'>
                            <store-card store={s} />
                        </div>
                    })
                }
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    beforeRouteEnter (to, from, next)
    {
        next(vm =>
        {
            const favoritesContainer = vm.$el.querySelector('#favorite-elements')
            if (LocalStorageUtils.useIntensiveAnimations)
            {
                let elements = favoritesContainer.querySelectorAll('.element')
                
                let delay = 0;

                elements.forEach(element =>
                {
                    element.style.visibility = 'hidden'
                    setTimeout(() =>
                    {
                        element.style.visibility = 'visible'
                        DOMUtils.animateCSS(element, 'zoomIn', '0.5s')
                    }, delay)

                    delay += 100;
                })
            }
            else
            {
                favoritesContainer.style.transition = 'none'
                favoritesContainer.style.opacity = 0
                setTimeout(() =>
                {
                    favoritesContainer.style.transition = 'opacity 0.3s linear'
                    favoritesContainer.style.opacity = 1
                }, 100)
            }
        })
    }, 

    methods:
    {
        // ..
    },

    components:
    {
        BackgroundIllustration,
        ViewTitle,
        CalEventItem,
        UsefulInfoCollapsible,
        StoreCard
    }
}
</script>

<style scoped lang='less'>
@import '~@/styles/main.less';

#favorites-view
{
    margin-top: 12vw;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 4vh);

    .OnDesktop({
        margin-top: 4vw;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });

    margin-left: 5vw;
    margin-right: 5vw;

            .OnTablet({ margin: 0 8vw; });
        .OnDesktop({ margin: 0 15vw; });

    > #favorite-elements
    {
        > .element
        {
            margin-bottom: 5vw;

            .OnDesktop({ margin-bottom: 2.5vh; });

            .image-tile
            {
                border-radius: 15px;
                padding: 4% 0%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Favorites.vue